<template>
  <div class="demo-layout">
    <div id="lbs-header" />
    <nuxt />
  </div>
</template>
<script>
export default {
  head() {
    return {
      meta: [
        { 'http-equiv': 'X-UA-Compatible', content: 'IE=Edge,chrome=1' },
        { name: 'viewport', content: 'width=1440' }
      ],
      link: [
        { rel: 'icon', type: 'image/x-icon', href: 'https://mapapi.qq.com/web/lbs/logo/favicon.ico' }
      ],
    };
  },
};
</script>
<style lang="scss">
.demo-layout #lbs-header {
  height: 72px;
  background-color: #020816;
}
.demo-layout {
  position: absolute;
  height: 100%;
  width: 100%;
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>
